import { gql } from '@apollo/client';

/**
 * Fetches plan features including add-on pricing.
 * Public query (no auth required).
 * add_ons is a JSONObject with structure:
 *   add_ons[key].price[currency][billingCycle].price
 *   e.g. add_ons['aericast'].price['usd']['monthly'].price = 20
 */
/**
 * Fetches a single plan feature by alias.
 * Used on SubscriptionPage to get current plan's name + addon pricing.
 */
export const PLAN_FEATURES_QUERY = gql`
  query PlanFeatures($query: PlanFeatureInput) {
    planFeatures(first: 1, query: $query) {
      page {
        edges {
          node {
            _id
            alias
            name
            plans
            features {
              name
              description
              enable
              checked
              isHide
            }
            add_ons
          }
        }
      }
    }
  }
`;

/**
 * Fetches all active plan features for the plan comparison/selection UI.
 * Returns name, alias, pricing, features list, description, order.
 */
export const ALL_PLAN_FEATURES_QUERY = gql`
  query AllPlanFeatures {
    planFeatures(first: 20) {
      page {
        edges {
          node {
            _id
            alias
            name
            description
            text
            order
            learnMoreURL
            plans
            features {
              name
              description
              enable
              checked
              isHide
            }
            add_ons
            isActive
          }
        }
      }
    }
  }
`;
